<template>
  <div class="text-xl font-sans font-medium py-24 relative min-h-screen blue-bkg">
    <!--Introduzione-->
    <div v-show="step === 1">
      <p class="px-8 text-white">
        {{ $t('Organizational and time management difficulties can be traced back to difficulties in the following four areas:') }}
      </p>
      <div class="flex flex-col mt-4 p-8 w-full">
        <button
        @click="step = 2"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow  text-sm"
        :class="{ done : active_el == 1 }">{{ $t('Confusions') }}</button>
        
        <button
        v-if="active_el >= 1"
        @click="step = 8"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm"
        :class="{ done : active_el_two == 2 }">{{ $t('Lack of planning') }}</button>

        <button
        v-else
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm opacity-40"
        :class="{ done : active_el_two == 2 }">{{ $t('Failure to plan') }}</button>


        <button
        v-if="active_el_two >= 2"
        @click="step = 15"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm"
        :class="{ done : active_el_three == 3 }">{{ $t('Performing roles you should delegate') }}</button>

        <button
        v-else
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm opacity-40"
        :class="{ done : active_el_three == 3 }">{{ $t('Performing roles you should delegate') }}</button>


        <button
        v-if="active_el_three >= 3"
        @click="step = 21"
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm">{{ $t('Compromises') }}</button>

        <button
        v-else
        class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow text-sm opacity-40">{{ $t('Compromises') }}</button>




      </div>
      <!-- <span>Clicca su uno dei tasti per approfondire.</span> -->
    </div>

    <!--Confusioni-->

    <div v-show="step === 2">
      <p class="px-8 text-white">{{ $t('The following questions will help you understand the causes of the confusion a little better') }}</p>
      <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
    </div>


      <div v-show="step === 3">
        <p class="px-8 text-white">{{ $t('Do you understand what your role in the company is?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer1 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer1 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 4">
        <p class="px-8 text-white">{{ $t('Do you know what the main goal of your role is?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer2 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer2 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 5">
        <p class="px-8 text-white">{{ $t('Is it clear what goals you set for yourself for this year?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer3 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer3 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 6">
        <p  class="px-8 text-white">{{ $t('Do you have a plan for today?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer4 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer4 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 7">
        <p class="px-8 text-white">{{ $t('Now the causes of the confusion should be a little clearer to you.') }}</p>
        
        <div class="p-8 text-white flex flex-col">
          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Clear role in the company') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <svg v-if="answer1 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Know the objective of the role') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer2 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>


          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Clear objectives for this year') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer3 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Plan for today') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer4 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>
        </div>

        <p class="px-8 text-white block">{{ $t('If you want, make a note somewhere about how you could manage it.') }}</p>

        <button @click="step = 1, activate(1)" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>
    

    <!--Mancata Pianificazione-->
 
      <div v-show="step === 8">
        <p class="px-8 text-white">{{ $t('Do you use an agenda to schedule your appointments?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer5 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer5 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 9">
        <p class="px-8 text-white">
          {{ $t('Do you have somewhere a list of your open cycles (all the open tasks you should complete, or the things you should do, both work and personal)?') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer6 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer6 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 10">
        <p class="px-8 text-white">
          {{ $t('The best organized people each week write a list of tasks to be done by taking them from their open projects list') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{$t('okay, I got it') }}
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 11">
        <p class="px-8 text-white">{{ $t('Do you have a written list of activities to be done during the week?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer7 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
           {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer7 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 12">
        <p class="px-8 text-white">
          {{ $t('Did you write a work plan for the day with the to-do list for today?') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer8 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
           {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer8 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 13">
        <p class="px-8 text-white">{{ $t('You should now be a little clearer to you what you should improve in planning:') }}</p>

        <div class="p-8 text-white flex flex-col">
          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Using the agenda') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <svg v-if="answer5 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('List of open cycles') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer6 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>


          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Weekly plan of activities to be carried out') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer7 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Plan for today') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer8 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>
        </div>

        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step++" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 14">
        <p class="px-8 text-white">{{ $t('Now write down the 3 priorities you want to focus on this week:') }}</p>
        
        <form @submit.prevent="submitPriority">
          <div class="mx-8 my-2">        
            <input type="text" id="priority_one" name="priority_one" v-model="priority_one" class="rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Priorità 1"/>
            <input type="text" id="priority_two" name="priority_two" v-model="priority_two"  class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Priorità 2"/>
            <input type="text" id="priority_three" name="priority_three" v-model="priority_three" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Priorità 3"/>
            <!-- <button type="submit"  class="inline-block w-auto bg-pink-600 text-white rounded-full text-xs font-semibold uppercase px-4 py-1 mt-4">ok</button> -->
            <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
            <button type="submit" @click="step = 1, activatetwo(2)" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
          </div>
        </form>
      </div>


    <!--Svolgere ruoli che potresti delegare-->
      <div v-show="step === 15">
        <p class="px-8 text-white">
          {{ $t('Do you play a managerial role while continuing in operational roles?') }}
        </p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 16">
        
        <div v-if="noHelp == 1">
          <p class="px-8 text-white">
            {{ $t('Are you carrying out roles that logically would have been assigned to your employees?') }}
          </p>
          <div class="flex flex-col mt-4 p-8 w-full">
            <button
              @click="noHelp = 2, answer9 = 1"
              class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
            >
              {{ $t('Yes') }}
            </button>
            <button
              @click="step++, answer9 = 0"
              class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
            >
              No
            </button>
          </div>
          <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        </div>

        <div v-if="noHelp == 2">
          <p class="px-8 text-white">
            {{ $t("If one of your collaborators has you do some of the activities in his/her role, or leaves them to you to manage, and you take charge of them, before long, he/she will also give you more of the activities that he/she should do. It's a vicious circle") }}
          </p>
          <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
          <button @click="noHelp = 3" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
        </div>

        <div v-if="noHelp == 3">
          <p class="px-8 text-white">
            {{ $t('Write down the name of your employee whom you need to help be more efficient: ') }}
          </p>
          <div class="my-2 mx-8">
            <input type="text" id="rounded-email" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Scrivi il suo nome"/>
            <button
              @click.prevent="next()"
              class="font-semibold w-full bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow block"
            >
              {{ $t('Does not apply to my situation') }}
            </button>
          </div>
          <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
          <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
        </div>

      </div>

      <div v-show="step === 17">
        <p class="px-8 text-white">{{ $t("Do you feel like you 'do everything yourself' and are you constantly late?") }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer10 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadoww"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer10 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 18">
        <p class="px-8 text-white">
      {{ $t('Know that the first functions you should delegate are those that you ALREADY perform very well, not those that you still do not know how to do.') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 19">
        <p class="px-8 text-white">
          {{ $t('To successfully delegate a task you should write a manual, understandable even to a stranger, that explains in exhaustive detail how you should carry out that activity (for example: the purpose of the activity, what you have to do when you arrive on Monday morning, the setting of the week, meetings, who are the clients, how they should be managed, etc., etc.)') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 20">
        <p class="px-8 text-white">{{ $t('Make a note of how you might manage:') }}</p>

        <div class="p-8 text-white flex flex-col">
          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Not-delegated operational roles') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <svg v-if="answer9 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Carry out activities that your employees get rid of') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer10 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>
        </div>
      
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click="step = 1, activatethree(3)" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>


      </div>
  

    <!--Compromessi-->
      <div v-show="step === 21">
        <p class="px-8 text-white">
         {{ $t("By 'compromise' we mean giving up of principles to obtain short-term advantage or letting things that make you feel bad pass through for a quiet living.") }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>


      <div v-show="step === 22">
        <p class="px-8 text-white">
          {{ $t('If you have so many compromises with people in your environment you lose the ability to plan') }}
        </p>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
      </div>

      <div v-show="step === 23">
        <p class="px-8 text-white">{{ $t('Do you have any compromises in the work environment?') }}</p>
        <div class="flex flex-col mt-4 p-8 w-full">
          <button
            @click="step++, answer11 = 1"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            {{ $t('Yes') }}
          </button>
          <button
            @click="step++, answer11 = 0"
            class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
          >
            No
          </button>
        </div>
        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
      </div>

      <div v-show="step === 24">
        <div v-if="noComp == false">
          <p class="px-8 text-white">{{ $t('Do you have compromises in your private sphere?') }}</p>
          <div class="flex flex-col mt-4 p-8 w-full">
            <button
              @click="noComp = true, answer12 = 1"
              class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
            >
              {{ $t('Yes') }}
            </button>
            <button
              @click="step++, answer12 = 0"
              class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
            >
              No
            </button>
          </div>
        </div>

        <div v-else>
          <p class="px-8 text-white">
            {{ $t('The person I sometimes go into compromise with that I should manage better is:') }}
          </p>
          <div class="my-2 mx-8">
            <input type="text" id="rounded-email" class=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent mb-2" placeholder="Scrivi il suo nome"/>
          <button
              click.prevent="next()"
              class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-black border border-black rounded-full shadow"
            >
              {{ $t('Does not apply to my situation') }}
            </button>
                     </div>

          <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
          <button @click.prevent="next()" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>
        </div>

      </div>




      <div v-show="step === 25">
        <p class="px-8 text-white">{{ $t('Make a note of how you might manage:') }}</p>

        <div class="p-8 text-white flex flex-col">
          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Compromises in the work environment') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <svg v-if="answer11 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>

          <div class="flex  justify-between border-gray-50 border-b pb-2 mb-2">
            <label for="">{{ $t('Compromises in the personal sphere') }}</label>
            <div class="bg-white border-2 rounded border-gray-400 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-blue-500">
              <input type="checkbox" class="opacity-0 absolute">
              <svg v-if="answer12 === 1" class="block fill-current w-6 h-6 text-green-500 pointer-events-none" viewBox="0 0 20 20"><path d="M0 11l2-2 5 5L18 3l2 2L7 18z"/></svg>
            </div>
          </div>
        </div>

        <button @click="step--" class="absolute left-10 bottom-20 rounded-full border-white border bg-transparent text-white font-large text-center h-16 w-16 font-bold">-</button>
        <button @click.prevent="next(), isComplete = true" class="absolute right-10 bottom-20 rounded-full bg-black text-white font-large text-center h-16 w-16 font-bold">ok</button>

      </div>


    <div v-if="isComplete == true && done[7] == 0" class="mx-8">
      <form @submit.prevent="submit">
      <audio autoplay>
        <source src="/sound/money.wav" type="audio/wav" />
      </audio>
      <ul class="flex flex-wrap justify-center">
        <li class="w-1/6">
          <img src="/img/osm-coin.png" alt="gem" />
        </li>
      </ul>
      <p class="p-8 text-center text-2xl text-white font-bold">
        {{ $t('Congratulations!') }}<br /> {{ $t('You have finished this improvement program!!!') }}<br />
        {{ $t("We've awarded you 0.5 OSM Coins!!!") }}        </p>
      <button
          type="submit"
          class="font-semibold w-full  bg-transparent my-2 py-2 px-4 text-white border border-white rounded-full shadow"
        >
          fine
        </button>
      </form>
    </div>

    <div v-if="isComplete == true && done[7] == 1" class="p-8">
      <h5 class="text-left text-2xl text-white font-bold">
        {{ $t('Congratulations!') }}<br /> {{ $t('You have completed this improvement program again!!!') }}<br />
      </h5>
      <inertia-link :href="route('curricula')" class="inline-block text-white py-2 px-6 border-2 border-white rounded-xl mt-16">
        fine
      </inertia-link>
    </div>

    
  </div>
</template>

<script>
export default {
   props: ['done'],
  data() {
    return {
      step: 1,
      progress: 0,
      isComplete: false,
      showYes: true,
      noHelp: 1,
      noComp: false,
      active_el: 0,
      active_el_two: 0,
      active_el_three: 0,
      program_id: 8,
      answer1: 0,
      answer2: 0,
      answer3: 0,
      answer4: 0,
      answer5: 0,
      answer6: 0,
      answer7: 0,
      answer8: 0,
      answer9: 0,
      answer10: 0,
      answer11: 0,
      answer12: 0,
      priority_one: null,
      priority_two: null,
      priority_three: null
    };
  },
  methods: {
    prev() {
      this.step--;
      var stepValue = 10;
      this.progress = this.progress - stepValue;
    },
    next(progress) {
      this.step++;
      var stepValue = 10;
      this.progress = this.progress + stepValue;
    },
    activate:function(el){
        this.active_el = el;
    },
    activatetwo:function(el){
        this.active_el_two = el;
    },
    activatethree:function(el){
        this.active_el_three = el;
    },
    submitPriority() {
      const data = new FormData()
      data.append('priority_one', this.priority_one);
      data.append('priority_two', this.priority_two);
      data.append('priority_three', this.priority_three);
      this.$inertia.post(this.route('details.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
    submit() {
      const data = new FormData()
      data.append('program_id', this.program_id)

      this.$inertia.post(this.route('workout.store'), data, {
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
      })
    },
  },
};
</script>

<style>
.done {
  background:#7ED321;
  font-weight:bold;
}

.blue-bkg {
background: #0D1944;
background: -webkit-linear-gradient(top, #0D1944, #429DCF);
background: -moz-linear-gradient(top, #0D1944, #429DCF);
background: linear-gradient(to bottom, #0D1944, #429DCF);
  }
</style>